import React from "react";
import ForgotPasswordForm from "./ForgotPasswordForm";

function ForgotPasswordPage() {
  return <ForgotPasswordForm />;
}

export default ForgotPasswordPage;
